
// If body has class page-careers, click the .video_title

jQuery(document).ready(function(){

	if(jQuery('body').hasClass('page-careers')){
		jQuery(".video__title").click();
	}
});



